import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/author/author-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/author/author-titles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/author/related-authors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/page-components/collection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/product/product-tags.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/tile-row.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/page-components/content.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/books-mosaic.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/tiles/series.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/card.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/styles/components/typography/heading.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
